import { useRef } from "react";
import { useNavigate } from "react-router-dom";

const SearchComponent = () => {
  const navigate = useNavigate();
  const headerSearch = useRef<HTMLInputElement>(null);
  const searchButtonHandler = () => {
    navigate(`/search?searchtext=${headerSearch.current?.value}`);
  }

  const searchKeyDownButtonHandler = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Enter") {
      navigate(`/search?searchtext=${headerSearch.current?.value}`);
    }
  };
  return (
    <>
      <div className="container">
        <div id="pnlSearch">
          <div className="search-box">
            <label htmlFor="txtKeyword" id="lblSearch" style={{ display: "none" }}>Search for:</label>
            <input type="hidden" name="txtKeyword_exWatermark_ClientState" id="txtKeyword_exWatermark_ClientState" />
            <input name="txtKeyword" type="text" placeholder="Search..." maxLength={1000} id="txtKeyword" className="search-box-input form-control" ref={headerSearch} onKeyDown={searchKeyDownButtonHandler} />
            <button className="search-box-submit" onClick={searchButtonHandler} >
              <i className="fa-solid fa-magnifying-glass"></i>
            </button>
            <input type="submit" name="btnSearch" id="btnSearch" className="visually-hidden btn" />
            <div className="col-xs-12 text-right">
              <div id="pnlPredictiveResultsHolder" className="predictiveSearchHolder">

              </div>
            </div>
          </div>
        </div>
      </div>
    </>);
};


export default SearchComponent;